// Display-only: turns the BACKEND permit readiness result into the office-facing
// vocabulary. No business logic here — it only renders what services/project_rules.py
// already calculated (received_at + expires_on). Used by every permit editor so the
// same record reads the same everywhere.

export const todayISO = () => new Date().toLocaleDateString("en-CA");

export function permitReadinessText(permit) {
  if (!permit) return { text: "—", tone: "neutral" };
  const state = permit.state || "invalid";
  const reason = permit.reason || "";
  const tone = state === "valid" ? "ready" : state === "warning" ? "warn" : "bad";
  const byReason = {
    "N/A": "Not Required",
    valid: "Ready",
    "does not expire": "Ready — Does not expire",
    expiring: "Expiring soon",
    expired: "Expired",
    "Missing required record": "Pending — no permit on file",
    "Permit not received": "Pending — mark received when in hand",
    "Received — expiration information required": "Not Ready — Expiration information required",
    "Received — expiration date required": "Not Ready — Expiration information required",
    "Unrecognized status — needs review": "Not Ready — status needs review",
  };
  return { text: byReason[reason] || reason || (state === "valid" ? "Ready" : "Not Ready"), tone };
}

// Canonical 811/Locate TIME condition (separate from the human Valid/Trouble/Remark).
export function locateReadinessText(locate) {
  if (!locate) return { text: "—", tone: "neutral" };
  const state = locate.state || "invalid";
  const reason = locate.reason || "";
  const tone = state === "valid" ? "ready" : state === "warning" ? "warn" : "bad";
  const byReason = {
    "N/A": "Not Required",
    valid: "Ready",
    "Ticket not needed": "Ticket not needed",
    "Missing required record": "Missing",
    "Expiration date required": "Expiration date required",
    "Locate expiration date must be refreshed": "Expired",
  };
  return { text: byReason[reason] || reason || (state === "valid" ? "Ready" : "Not Ready"), tone };
}

// Compact label (no kicker) for board columns / list rows — same canonical source.
export function PermitReadinessLabel({ state, reason, testId }) {
  const { text, tone } = permitReadinessText({ state, reason });
  return <span className={`permit-calc-inline permit-calc-${tone}`} data-testid={testId}>{text}</span>;
}

export function LocateReadinessLabel({ state, reason, testId }) {
  const { text, tone } = locateReadinessText({ state, reason });
  return <span className={`permit-calc-inline permit-calc-${tone}`} data-testid={testId}>{text}</span>;
}

export function PermitCalculatedBadge({ readiness, testId }) {
  const permit = readiness && readiness.permit;
  if (!permit) return null;
  const { text, tone } = permitReadinessText(permit);
  return (
    <span className={`permit-calc-badge permit-calc-${tone}`} data-testid={testId}>
      <span className="permit-calc-kicker">JFM calculated</span>
      {text}
    </span>
  );
}
